import { useDispatch, useSelector } from "react-redux";
import useHandleRedirect from '../../Hooks/useHandleRedirect';
import * as authActions from '../../Redux/Auth/AuthActions';
import Layout from "../../Utils/Navbar/navbar-layout-component";
import { getNotFoundData } from "../../Public/not-found-data";
import { ButtonPrimary } from "../../Utils/Buttons/button-component";
import Image from "../../Utils/Image/image-component";

function NotFound() {
    const dispatch = useDispatch();
    const navigate = useHandleRedirect({ onReduxRedirect: (path) => dispatch(authActions.redirectScreen(path)) });

    // 1. System Context & Localization
    const { language = 'en', dir } = useSelector((state) => state.systemData || {});
    const txt = getNotFoundData(language);

    const handleRedirect = () => navigate('/');

    /**
     * Splits by space and groups words
     * 404 (Primary) NOT FOUND (Secondary/Orange)
     */
    const renderTitle = (text) => {
        if (!text) return null;
        const words = text.split(' ');

        const group1 = words.slice(0, 1).join(' '); // "404"
        const group2 = words.slice(1).join(' ');    // "NOT FOUND"

        return (
            <>
                {group1}
                <span className="text-secondary-500"> {group2}</span>
            </>
        );
    };

    return (
        <Layout seo={txt.seo}>
            <div dir={dir} className="min-h-screen w-full bg-white font-assistant flex flex-col items-center justify-center relative overflow-hidden">

                {/* Visual Blueprint Grid Overlay */}
                <div className="absolute inset-0 opacity-[0.03] pointer-events-none bg-[radial-gradient(#003366_1px,transparent_1px)] [background-size:40px_40px]"></div>

                <main className="relative z-10 w-full max-w-7xl px-6 py-20 flex flex-col items-center text-center">

                    {/* High-Impact Header */}
                    <h1 className="text-6xl md:text-8xl lg:text-[10rem] font-black text-primary-900 leading-none uppercase er mb-12">
                        {renderTitle(txt.title)}
                    </h1>

                    <div className="w-full max-w-lg mb-12 transform hover:rotate-1 transition-transform duration-700">
                        <Image
                            src={txt.image} // Pulling directly from the ASSETS defined in data
                            alt="404 Illustration"
                            className="w-full h-auto object-contain"
                            useSekeleton={false}
                        />
                    </div>

                    {/* Content Section */}
                    <div className="max-w-2xl space-y-6">
                        <h2 className="text-3xl md:text-5xl font-black text-slate-900 uppercase ">
                            {txt.subtitle}
                        </h2>
                        <p className="text-xl md:text-2xl text-slate-500 font-medium italic leading-relaxed">
                            {txt.description}
                        </p>

                        <div className="pt-10 flex justify-center">
                            <ButtonPrimary
                                onClick={handleRedirect}
                                size="lg"
                                className="!rounded-full px-16 py-6 text-xl uppercase font-black tracking-widest shadow-2xl shadow-blue-500/20"
                            >
                                {txt.buttonText}
                            </ButtonPrimary>
                        </div>
                    </div>
                </main>
            </div>
        </Layout>
    );
}

export default NotFound;